(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["petco-halloween-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('petco-halloween-bar')) return;

    class PetcoHalloweenBar extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.start());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.tickTimer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        (this.units || []).forEach(unit => clearTimeout(unit.finishTimer));
      }

      finish() {
        this.expired = true;
        clearTimeout(this.tickTimer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.hidden = true;
      }

      start() {
        if (!this.isConnected) return;
        this.timer = this.querySelector('[role="timer"]');
        if (!this.timer) return;
        this.description = this.querySelector('[data-time-description]');
        this.speed = Number(this.dataset.speed) || 600;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.units = Array.from(this.querySelectorAll('[data-unit]'), node => ({
          label: node.dataset.label,
          card: node.querySelector('.pc-hw__card'),
          top: node.querySelector('[data-top]'),
          bottom: node.querySelector('[data-bottom]'),
          out: node.querySelector('[data-out]'),
          incoming: node.querySelector('[data-in]'),
          value: null
        }));

        // Require an explicit UTC offset so every visitor sees the same deadline.
        const iso = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/;
        this.deadline = iso.test(this.dataset.end || '') ? Date.parse(this.dataset.end) : NaN;
        if (!Number.isFinite(this.deadline)) {
          console.warn('PET & Co.: Bitte eine gültige ISO-Endzeit mit UTC-Versatz eintragen.');
          this.finish();
          return;
        }
        if (Date.now() >= this.deadline) {
          this.finish();
          return;
        }
        this.timer.hidden = false;

        this.onVisibility = () => {
          clearTimeout(this.tickTimer);
          if (this.expired) return;
          if (!document.hidden) this.tick(false);
          else this.units.forEach(unit => this.settle(unit));
        };
        document.addEventListener('visibilitychange', this.onVisibility);
        this.tick(false);
      }

      settle(unit) {
        clearTimeout(unit.finishTimer);
        unit.card.classList.remove('is-flipping');
        if (unit.value !== null) {
          [unit.top, unit.bottom, unit.out, unit.incoming].forEach(node => { node.textContent = unit.value; });
        }
      }

      updateUnit(unit, value, animate) {
        const next = String(value).padStart(2, '0');
        if (next === unit.value) return;
        const previous = unit.value;
        this.settle(unit);
        unit.value = next;
        unit.card.classList.toggle('is-wide', next.length > 2);
        if (!animate || previous === null || this.motion.matches) {
          this.settle(unit);
          return;
        }
        unit.top.textContent = next;
        unit.bottom.textContent = previous;
        unit.out.textContent = previous;
        unit.incoming.textContent = next;
        void unit.card.offsetWidth;
        unit.card.classList.add('is-flipping');
        unit.finishTimer = setTimeout(() => this.settle(unit), this.speed + 30);
      }

      tick(animate) {
        clearTimeout(this.tickTimer);
        if (!this.isConnected) return;
        const now = Date.now();
        if (now >= this.deadline) {
          this.finish();
          return;
        }
        const remaining = Math.ceil((this.deadline - now) / 1000);
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        this.units.forEach((unit, index) => this.updateUnit(unit, values[index], animate));
        this.description.textContent = this.units.map((unit, index) => `${values[index]} ${unit.label}`).join(', ');
        if (!document.hidden) {
          const untilNextSecond = (this.deadline - now) % 1000 || 1000;
          this.tickTimer = setTimeout(() => this.tick(true), Math.max(30, untilNextSecond) + 15);
        }
      }
    }

    customElements.define('petco-halloween-bar', PetcoHalloweenBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-selector"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function parseSlots(value) {
      if (!value) return [];
      try {
        return JSON.parse(value);
      } catch (error) {
        return [];
      }
    }

    function fill(template, vars) {
      return Object.keys(vars).reduce(function (text, key) {
        return text
          .replace(new RegExp('\\[' + key + '\\]', 'g'), vars[key])
          .replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g'), vars[key]);
      }, template || '');
    }

    function plainText(value) {
      var el = document.createElement('div');
      el.innerHTML = value || '';
      return (el.textContent || '').trim();
    }

    function summarizePicks(picks) {
      var counts = {};
      var order = [];
      picks.forEach(function (title) {
        if (!counts[title]) {
          counts[title] = 0;
          order.push(title);
        }
        counts[title] += 1;
      });
      return order.map(function (title) {
        return counts[title] > 1 ? counts[title] + '× ' + title : title;
      }).join(', ');
    }

    function init(root) {
      if (!root || root.dataset.subselBound === 'true') return;
      root.dataset.subselBound = 'true';

      var state = {
        plan: null,
        picks: {},
        frequency: null
      };

      var builder = root.querySelector('[data-builder]');
      var slotsWrap = root.querySelector('[data-slots-wrap]');
      var itemSource = root.querySelector('.subsel-items-source');
      var slotTemplate = root.querySelector('[data-slot-template]');
      var submit = root.querySelector('[data-submit]');
      var submitLabel = root.querySelector('[data-submit-label]');
      var progress = root.querySelector('[data-progress]');
      var builderTitle = root.querySelector('[data-builder-title]');
      var builderSubtitle = root.querySelector('[data-builder-subtitle]');
      var builderMeta = root.querySelector('[data-builder-meta]');

      function isMobileLayout() {
        return window.matchMedia('(max-width: 989px)').matches;
      }

      function planSubtitle(plan) {
        var subtitle = plan.querySelector('.subsel-plan__subtitle');
        return subtitle ? (subtitle.textContent || '').trim() : '';
      }

      function planDetailsText(plan) {
        var details = plan.querySelector('.subsel-plan__details');
        if (!details) return '';
        var holder = document.createElement('div');
        holder.innerHTML = (details.innerHTML || '').replace(/<br\s*\/?>/gi, ' ');
        return (holder.textContent || '').replace(/\s+/g, ' ').trim();
      }

      function slots() {
        return state.plan ? parseSlots(state.plan.getAttribute('data-slots')) : [];
      }

      function slotPicks(key) {
        return state.picks[key] || [];
      }

      function totals() {
        var all = slots();
        var required = 0;
        var selected = 0;
        all.forEach(function (slot) {
          required += Number(slot.qty) || 0;
          selected += slotPicks(slot.key).length;
        });
        return { required: required, selected: selected };
      }

      function selectedSellingPlanId() {
        if (!state.frequency) return 0;
        var id = Number(state.frequency.getAttribute('data-selling-plan'));
        return id > 0 ? id : 0;
      }

      function isComplete() {
        if (!state.plan) return false;
        if (state.plan.getAttribute('data-available') !== 'true') return false;
        var all = slots();
        for (var i = 0; i < all.length; i++) {
          if (slotPicks(all[i].key).length !== Number(all[i].qty)) return false;
        }
        if (!selectedSellingPlanId()) return false;
        return true;
      }

      function updateCta() {
        if (!submit) return;
        var title = state.plan ? state.plan.getAttribute('data-title') : '';
        var price = state.plan ? plainText(state.plan.getAttribute('data-price-formatted')) : '';
        submitLabel.textContent = fill(root.getAttribute('data-cta-template'), {
          title: title,
          price: price
        });
        submit.disabled = !isComplete();
      }

      function updateProgress() {
        var counts = totals();
        if (progress) {
          progress.textContent = counts.required
            ? fill(root.getAttribute('data-progress-template'), {
                selected: String(counts.selected),
                total: String(counts.required)
              })
            : '';
        }
        root.querySelectorAll('[data-slot-section]').forEach(function (sectionEl) {
          var key = sectionEl.getAttribute('data-slot-key');
          var slot = slots().find(function (entry) { return entry.key === key; });
          if (!slot) return;
          var selected = slotPicks(key).length;
          var countEl = sectionEl.querySelector('[data-slot-count]');
          var hintEl = sectionEl.querySelector('[data-slot-hint]');
          if (countEl) {
            countEl.textContent = fill(root.getAttribute('data-slot-count-template'), {
              selected: String(selected),
              required: String(slot.qty)
            });
          }
          if (hintEl) {
            var remaining = Math.max(slot.qty - selected, 0);
            hintEl.textContent = remaining
              ? fill(root.getAttribute('data-slot-open-template'), { remaining: String(remaining) })
              : '';
          }
          sectionEl.classList.toggle('is-complete', selected === Number(slot.qty));
          paintMeter(sectionEl, selected, Number(slot.qty));
        });
        updateCta();
      }

      function paintMeter(sectionEl, selected, required) {
        var meter = sectionEl.querySelector('[data-slot-meter]');
        if (!meter) return;
        var total = Math.max(required, 0);
        if (meter.childElementCount !== total) {
          meter.replaceChildren();
          for (var i = 0; i < total; i++) {
            var segment = document.createElement('span');
            segment.className = 'subsel-slot__meter-seg';
            meter.appendChild(segment);
          }
        }
        Array.prototype.forEach.call(meter.children, function (segment, index) {
          segment.classList.toggle('is-filled', index < selected);
        });
        meter.setAttribute('aria-valuenow', String(selected));
        meter.setAttribute('aria-valuemax', String(total));
        meter.setAttribute('aria-valuetext', selected + ' / ' + total);
      }

      var toastTimer = null;
      function showMaxToast(slot, sectionEl) {
        var toast = root.querySelector('[data-max-toast-el]');
        if (!toast) return;
        var selected = slotPicks(slot.key).length;
        toast.textContent = fill(root.getAttribute('data-max-toast'), {
          heading: slot.heading || slot.key,
          selected: String(selected),
          required: String(slot.qty)
        });
        toast.classList.add('is-visible');
        if (sectionEl) {
          sectionEl.classList.remove('is-bump');
          void sectionEl.offsetWidth;
          sectionEl.classList.add('is-bump');
        }
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () {
          toast.classList.remove('is-visible');
        }, 2600);
      }

      function syncItemButtons(sectionEl, key) {
        var picks = slotPicks(key);
        var slot = slots().find(function (entry) { return entry.key === key; });
        var max = slot ? Number(slot.qty) : 0;
        var counts = {};
        picks.forEach(function (title) {
          counts[title] = (counts[title] || 0) + 1;
        });
        sectionEl.querySelectorAll('[data-item]').forEach(function (item) {
          var title = item.getAttribute('data-title');
          var qty = counts[title] || 0;
          item.classList.toggle('is-selected', qty > 0);
          var qtyEl = item.querySelector('[data-item-qty]');
          var minusEl = item.querySelector('[data-item-minus]');
          var plusEl = item.querySelector('[data-item-plus]');
          if (qtyEl) {
            qtyEl.textContent = String(qty);
            qtyEl.classList.toggle('is-active', qty > 0);
          }
          if (minusEl) minusEl.disabled = qty < 1;
          if (plusEl) {
            var atMax = picks.length >= max;
            plusEl.disabled = false;
            plusEl.classList.toggle('is-maxed', atMax);
            plusEl.setAttribute('aria-disabled', atMax ? 'true' : 'false');
          }
        });
      }

      function itemAllowed(button, planTitle, variantId) {
        var allowed = (button.getAttribute('data-plans') || '').trim();
        if (!allowed) return true;
        return allowed.split(',').some(function (part) {
          var value = part.trim().toLowerCase();
          return value === String(variantId) || value === String(planTitle).toLowerCase();
        });
      }

      function renderSlots() {
        if (!slotsWrap || !slotTemplate) return;
        slotsWrap.innerHTML = '';
        state.picks = {};
        var planTitle = state.plan.getAttribute('data-title');
        var variantId = state.plan.getAttribute('data-variant-id');

        slots().forEach(function (slot) {
          state.picks[slot.key] = [];
          var sectionEl = slotTemplate.content.firstElementChild.cloneNode(true);
          sectionEl.setAttribute('data-slot-key', slot.key);
          sectionEl.querySelector('[data-slot-heading]').textContent = slot.heading || slot.key;
          var grid = sectionEl.querySelector('[data-slot-grid]');
          if (itemSource) {
            itemSource.querySelectorAll('[data-item]').forEach(function (item) {
              if (item.getAttribute('data-slot') !== slot.key) return;
              if (!itemAllowed(item, planTitle, variantId)) return;
              grid.appendChild(item.cloneNode(true));
            });
          }
          grid.addEventListener('click', function (event) {
            var item = event.target.closest('[data-item]');
            if (!item) return;
            var title = item.getAttribute('data-title');
            var current = slotPicks(slot.key).slice();
            var max = Number(slot.qty);
            var selectedIndex = current.lastIndexOf(title);
            var isMinus = Boolean(event.target.closest('[data-item-minus]'));

            if (isMinus) {
              if (selectedIndex === -1) return;
              current.splice(selectedIndex, 1);
            } else if (current.length < max) {
              current.push(title);
            } else {
              showMaxToast(slot, sectionEl);
              return;
            }

            state.picks[slot.key] = current;
            syncItemButtons(sectionEl, slot.key);
            updateProgress();
          });
          slotsWrap.appendChild(sectionEl);
          syncItemButtons(sectionEl, slot.key);
        });
        updateProgress();
      }

      function slideIndicator(animate) {
        if (!isMobileLayout()) return;
        var plans = root.querySelector('.subsel__plans');
        var indicator = plans && plans.querySelector('.subsel-tabs__indicator');
        var selected = plans && plans.querySelector('.subsel-plan.is-selected .subsel-tab');
        if (!plans || !indicator || !selected) return;
        var plansRect = plans.getBoundingClientRect();
        var tabRect = selected.getBoundingClientRect();
        indicator.classList.toggle('is-instant', !animate);
        indicator.style.width = tabRect.width + 'px';
        indicator.style.height = tabRect.height + 'px';
        indicator.style.transform = 'translate(' + (tabRect.left - plansRect.left) + 'px, ' + (tabRect.top - plansRect.top) + 'px)';
        plans.classList.add('has-indicator');
      }

      function animatePanel(previous, next) {
        if (!builder || !isMobileLayout() || !previous || previous === next) return;
        builder.classList.remove('is-switching');
        void builder.offsetWidth;
        builder.classList.add('is-switching');
      }

      function selectPlan(plan, options) {
        options = options || {};
        if (!plan) return;
        var previous = state.plan;
        state.plan = plan;
        state.frequency = null;
        root.querySelectorAll('[data-plan]').forEach(function (card) {
          var selected = card === plan;
          card.classList.toggle('is-selected', selected);
          card.querySelectorAll('[data-plan-select]').forEach(function (button) {
            var selectedState = selected ? 'true' : 'false';
            button.setAttribute('aria-pressed', selectedState);
            if (button.getAttribute('role') === 'tab') button.setAttribute('aria-selected', selectedState);
          });
        });
        root.querySelectorAll('[data-frequency]').forEach(function (button) {
          button.classList.remove('is-selected');
        });
        if (builder) {
          builder.hidden = false;
          builderTitle.textContent = plan.getAttribute('data-title') + ' — ' + plainText(plan.getAttribute('data-price-formatted'));
          if (builderSubtitle) {
            var subtitle = planSubtitle(plan);
            builderSubtitle.textContent = subtitle;
            builderSubtitle.hidden = !subtitle;
          }
          if (builderMeta) builderMeta.textContent = planDetailsText(plan);
        }
        renderSlots();
        slideIndicator(Boolean(previous) && previous !== plan);
        animatePanel(previous, plan);
        if (options.scroll !== false && builder) {
          builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      function selectDefaultPlan() {
        if (!isMobileLayout() || state.plan) return;
        var first = root.querySelector('[data-plan][data-available="true"]') || root.querySelector('[data-plan]');
        if (first) selectPlan(first, { scroll: false });
      }

      root.addEventListener('click', function (event) {
        var planButton = event.target.closest('[data-plan-select]');
        if (planButton) {
          var nextPlan = planButton.closest('[data-plan]');
          if (planButton.classList.contains('subsel-tab') && nextPlan === state.plan) return;
          selectPlan(nextPlan, { scroll: !isMobileLayout() });
          return;
        }
        var frequency = event.target.closest('[data-frequency]');
        if (frequency) {
          state.frequency = frequency;
          root.querySelectorAll('[data-frequency]').forEach(function (button) {
            button.classList.toggle('is-selected', button === frequency);
          });
          updateCta();
        }
      });

      if (submit) {
        submit.addEventListener('click', function () {
          if (!isComplete()) {
            window.alert(root.getAttribute('data-incomplete'));
            return;
          }

          var properties = {};
          var planTitle = state.plan.getAttribute('data-title') || '';
          var variantTitle = state.plan.getAttribute('data-variant-title') || '';
          var planName = (root.getAttribute('data-plan-property') || '').trim();
          if (planName && planTitle && planTitle !== variantTitle) {
            properties[planName] = planTitle;
          }

          slots().forEach(function (slot) {
            var picks = slotPicks(slot.key);
            if (!picks.length) return;
            var propertyBase = (slot.property || slot.key || '').trim();
            if (!propertyBase) return;
            properties[propertyBase] = summarizePicks(picks);
          });

          if (state.frequency) {
            var frequencyName = root.getAttribute('data-frequency-property');
            if (frequencyName) properties[frequencyName] = state.frequency.getAttribute('data-value');
          }

          var payload = {
            items: [{
              id: Number(state.plan.getAttribute('data-variant-id')),
              quantity: 1,
              properties: properties
            }]
          };

          var sellingPlan = selectedSellingPlanId();
          if (!sellingPlan) {
            window.alert(root.getAttribute('data-missing-plan'));
            return;
          }
          payload.items[0].selling_plan = sellingPlan;

          var original = submitLabel.textContent;
          submit.disabled = true;
          submitLabel.textContent = root.getAttribute('data-adding');

          fetch(root.getAttribute('data-cart-add') || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          }).then(function (response) {
            if (!response.ok) throw new Error('add-failed');
            if (typeof reloadCart === 'function') {
              reloadCart(function () {
                if (typeof openCartDrawer === 'function') openCartDrawer();
              });
            } else {
              window.location.href = '/cart';
            }
          }).catch(function () {
            window.alert(root.getAttribute('data-error'));
          }).finally(function () {
            submitLabel.textContent = original;
            updateCta();
          });
        });
      }

      var featured = root.querySelector('[data-plan][data-featured="true"]') || root.querySelector('[data-plan][data-available="true"]');
      if (featured && root.closest('html')) {
        featured.classList.add('is-featured');
      }

      selectDefaultPlan();
      slideIndicator(false);
      if (window.matchMedia) {
        var mobileMedia = window.matchMedia('(max-width: 989px)');
        if (mobileMedia.addEventListener) {
          mobileMedia.addEventListener('change', function () {
            selectDefaultPlan();
            slideIndicator(false);
          });
        }
      }
      var plansEl = root.querySelector('.subsel__plans');
      if (plansEl && window.ResizeObserver) {
        var lastPlansWidth = plansEl.clientWidth;
        new ResizeObserver(function () {
          if (plansEl.clientWidth === lastPlansWidth) return;
          lastPlansWidth = plansEl.clientWidth;
          slideIndicator(false);
        }).observe(plansEl);
      }
    }

    function revealIdDebug() {
      if (!(window.Shopify && Shopify.designMode)) return;
      document.querySelectorAll('[data-id-debug]').forEach(function (el) {
        el.hidden = false;
      });
    }

    function initAll() {
      document.querySelectorAll('[data-subsel-root]').forEach(init);
      revealIdDebug();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
